import { Check, ChevronRight, Search } from 'lucide-react'
import { useMemo, useState } from 'react'
import type { PedagogyPriorityPartnerOption } from '@/services/pedagogyPriorityRequestService'

export function PriorityPartnerPicker({
  options,
  value,
  loading,
  onSelect,
}: {
  options: PedagogyPriorityPartnerOption[]
  value: string
  loading: boolean
  onSelect: (value: string) => void
}) {
  const [query, setQuery] = useState('')

  const filtered = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase('ru')
    if (!normalized) return options
    return options.filter(option => `${option.partnerName} ${option.partnerNumber}`
      .toLocaleLowerCase('ru')
      .includes(normalized))
  }, [options, query])

  if (loading) {
    return (
      <div className="rounded-xl border border-border bg-muted/20 px-4 py-6 text-center text-sm text-muted-foreground">
        Загружаем франчайзи…
      </div>
    )
  }

  return (
    <div className="space-y-2.5">
      <div className="relative">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          type="search"
          value={query}
          onChange={event => setQuery(event.target.value)}
          placeholder="Найти франчайзи"
          className="input h-9 w-full pl-9 text-sm"
          autoFocus
        />
      </div>

      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{query ? `Найдено: ${filtered.length}` : `Доступно: ${options.length}`}</span>
        <span>занятия за 7 дней</span>
      </div>

      <div
        className="max-h-[52vh] touch-pan-y overflow-y-auto overscroll-contain rounded-xl border border-border bg-card p-1"
        style={{ WebkitOverflowScrolling: 'touch' }}
      >
        {filtered.length > 0 ? filtered.map(option => {
          const selected = value === String(option.partnerNumber)
          return (
            <button
              key={option.partnerNumber}
              type="button"
              onClick={() => onSelect(String(option.partnerNumber))}
              className={`flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left transition-colors ${
                selected ? 'bg-primary/10 text-primary' : 'hover:bg-muted/60'
              }`}
            >
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground">{option.partnerName}</span>
                <span className="mt-0.5 block text-[11px] text-muted-foreground">
                  №{option.partnerNumber} · {option.availableSessions} доступных занятий
                </span>
              </span>
              {selected ? (
                <Check className="h-4 w-4 shrink-0 text-primary" />
              ) : (
                <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
              )}
            </button>
          )
        }) : (
          <div className="px-4 py-8 text-center text-sm text-muted-foreground">
            Франчайзи не найден.
          </div>
        )}
      </div>
    </div>
  )
}
